import React from 'react'
import { graphql } from 'gatsby';
import { Typography } from 'antd';
import Layout from "../../../components/Layout";
import "../../../styles/odooServices.scss"
import "../../../styles/services.scss"
import "../../../styles/caseStudy.scss"
import News from '../../../components/News'
import ProductTopSection from '../../../components/ProductTopSelection';
import ServiceCard from '../../../components/ServiceCard';
import Wethoughtyoumighthavequestions from '../../../components/Wethoughtyoumighthavequestions'
import CaseStudeiesSimplified from '../../../components/CaseStudeiesSimplified'
import ImageWithTextSection from '../../../components/ImageWithTextSection';
import IconsAdded from '../../../components/IconsAdded';
import sc_performance from '../../../images/servicecard/performance.png';
import sc_integration from '../../../images/servicecard/integration.png';
import sc_cloud from '../../../images/servicecard/cloud.png';
import sc_legacy from '../../../images/servicecard/legacy.png';
import sc_deployment from '../../../images/servicecard/deployment.png';
import sc_testing from '../../../images/servicecard/Automated testing.png';

const { Title } = Typography

const MicD365XstakIntegration = ({ data }) => {
  return (
    <div className='CaseStudeies'>
      <Layout pageTitle={"Visiomate - Microsoft Dynamics 365 Xstak Integration"}
      descrip = {"Unlock the full potential of your Dynamics 365 with Xstak integration. Gain deeper insights, automate processes, and drive business growth."}>
        <ProductTopSection
          headerData={{
            title: "Visiopack: a complete ERP system best suited for many industries i.e Any Retails, Restaurant, Complex Warehousing etc.  ",
            peragraph: "Indulge in the extraordinary with Visiopack—an Odoo-based solution meticulously crafted exclusively for your business needs. Elevate your operations, streamline efficiency, and experience unparalleled simplicity tailored just for you.",
          }}
          data={data} />
          <div className="services-page-container position-relative">
          <div className="services-description-section">
            <div className="service-heading-and-detail">
              <Title>The Business Edge Visiopack Delivers</Title>
            </div>
            <div className="service-cards-wrapper">
              <ServiceCard
                img_src={sc_performance}
                img_alt="Operational Efficiency"
                card_heading="Operational Efficiency"
                card_para="Visiopack optimizes business processes, automating routine tasks and fostering a more efficient operational environment."
              />
              <ServiceCard
                img_src={sc_integration}
                img_alt="Enhanced Collaboration"
                card_heading="Enhanced Collaboration"
                card_para="Visiopack serves as a hub for collaboration, fostering seamless communication and information sharing across different departments."
              />
              <ServiceCard
                img_src={sc_cloud}
                img_alt="Optimized Inventory Control"
                card_heading="Optimized Inventory Control"
                card_para="Visiopack streamlines inventory management, reducing holding costs, and ensuring timely fulfillment of orders."
              />
              <ServiceCard
                img_src={sc_legacy}
                img_alt="Informed Decision-Making"
                card_heading="Informed Decision-Making"
                card_para="Real-time access to accurate data in Visiopack empowers decision-makers, enabling them to make strategic choices that positively impact the organization."
              />
              <ServiceCard
                img_src={sc_deployment}
                img_alt="Holistic Data Integration"
                card_heading="Holistic Data Integration"
                card_para="Integration of data across departments in Visiopack provides a comprehensive view of the organization, allowing for better-informed decision-making."
              />
              <ServiceCard
                img_src={sc_testing}
                img_alt="Time and Cost Savings"
                card_heading="Time and Cost Savings"
                card_para="Automation of tasks, such as inventory management and sales reporting, saves time and reduces the need for manual labor."
              />
            </div>
          </div>
        </div>
        <ImageWithTextSection
          title="What Visiopack Can Do for You"
          caseStudyData={{
            data: [
              {
                heading: "Touch Friendly POS Interface for Retailers",
                description:
                  "The touch-friendly interface streamlines transactions, allowing users to easily navigate through menus, select items, and process payments with a simple tap or swipe.",
              },
              {
                heading: "Shop Demand Management",
                description:
                  "Efficient demand management helps businesses maintain optimal inventory levels by aligning stock levels with actual customer demand.",
              },
              {
                heading: "Orders History & Refund ",
                description:
                  "A detailed order history allows customers to track their purchases, view past transactions, and monitor the status of their orders. An efficient refund system ensures that customers receive timely reimbursements, contributing",
              },
              {
                heading: "Multiple Payment Methods",
                description:
                  "Our solution ensures seamless payment experiences by effortlessly configuring multiple payment methods. Embrace the future of payments with ease and versatility.",
              },
              {
                heading: "Dynamic Kitchen Preparation Screen",
                description:
                  "This technology leverages dynamic, real-time information to enhance communication and coordination between the kitchen staff, improving overall kitchen operations.",
              },
              {
                heading: "Order Status Screen for Cusotmers",
                description:
                  "Ensuring that the KOT screen is automatically updated with new orders and reflects any changes made at the Serving front.",
              },
              {
                heading: "Robust Filtration ",
                description:
                  "Offer a seamless data exploration experience with advanced filters for refining data based on parameters like date ranges and categories. Enhance data retrieval with dynamic search functionality and enable complex queries through multi-criteria filtration",
              },
              {
                heading: "Personalized Data Views",
                description:
                  "Tailor the data view to individual preferences through customizable views, allowing users to adjust columns, layout, and arrangement.",
              },
              {
                heading: "Kanban / Card View",
                description:
                  "It provides a clear, real-time overview of tasks, allowing teams to see the status of work at a glance. Users can drag and drop cards between columns, making it easy to track progress and manage tasks in a visual and intuitive way.",
              },
              {
                heading: "List Data View",
                description:
                  "It is a structured and detailed representation that allows users to view and manipulate data in a spreadsheet-like format.",
              },
              {
                heading: "Mobile app for sales overview & purchase processing",
                description:
                  "A detailed order history allows customers to track their purchases, view past transactions, and monitor the status of their orders. An efficient refund system ensures that customers receive timely reimbursements, contributing",
              },
              {
                heading: "Dashboards",
                description:
                  " Graphs, charts, and other visual elements make complex data more comprehensible, enabling users to quickly grasp trends, patterns, and outliers.",
              },
              {
                heading: "Reporting & Analysis",
                description:
                  "Analytics help identify trends and patterns in sales, customer behavior, and market dynamics, allowing businesses to capitalize on opportunities and mitigate challenges.",
              },
            ],
          }}
          dataFormImages={data} />
        {/* <CaseStudeiesSimplified
          TextData={{
            title: 'Simplified Steps to get you Started '
            ,
            Data: [
              {
                peragraph: 'Define Requirements',
                list: [
                  'Clearly outline your business objectives and identify the specific challenges or needs that the software solution should address.',
                  'List down the essential features and functionalities required.'
                ]
              },
              {
                peragraph: 'Demo and Evaluation',
                list: [
                  "Schedule product demonstrations. ",
                  "Evaluate the software's usability, features, and performance. ",
                  "Engage key stakeholders in the evaluation process."
                ]
              },
              {
                peragraph: 'Scalability and Integration',
                list: [
                  "Identify the potential integrations required by the customer.",
                  "Plan the implementation of identified integrations."
                ]
              },
              {
                peragraph: 'UAT & User Feedback',
                list: [
                  "UAT period allows customer to assess the system performance and suitability for the specific business needs.",
                  "Customer’s insights can provide valuable perspectives on usability, functionality mismatch."
                ]
              },
              {
                peragraph: 'User Training',
                list: [
                  " User training is a critical component of successfully implementing the software solution.",
                  "Proper training ensures that users can effectively and efficiently utilize the software, maximizing its benefits."
                ]
              },
              {
                peragraph: 'Post-Implementation Support',
                list: [
                  "Provide ongoing support for users.",
                  "Address any post-implementation issues.",
                  "Evaluate and implement system enhancements based on feedback.",
                ]
              }
            ]
          }} /> */}
        <Wethoughtyoumighthavequestions

          data={[
            {
              question: "What is Visiopack?",
              answer: "Visiopack is a comprehensive Odoo-based ERP solution tailored for retail, restaurant, and complex warehousing businesses. It brings together inventory, sales, purchasing, finance, HR, and POS into a single unified platform — eliminating data silos and reducing operational complexity.",
            },
            {
              question: "Which industries is Visiopack best suited for?",
              answer: "Visiopack is designed for retail chains, restaurants, food and beverage businesses, wholesale distributors, and businesses with complex warehousing needs. Its modular design means it adapts to your industry without requiring heavy customization.",
            },
            {
              question: "How long does a Visiopack implementation take?",
              answer: "A standard Visiopack implementation typically takes 2–6 weeks depending on scope, data migration requirements, and customization. Our team follows a structured onboarding process to get you live quickly and confidently.",
            },
            {
              question: "Can Visiopack be customized for our specific workflows?",
              answer: "Absolutely. Visiopack is solution-first — we don't sell a fixed product. Our team works with you to configure modules, build custom workflows, and add any specialized features your business requires.",
            },
            {
              question: "What support is available after go-live?",
              answer: "We provide dedicated post-go-live support including a helpdesk, regular system health checks, and access to training resources. Our team remains available to resolve issues, roll out updates, and guide your team as the business scales.",
            },
            {
              question: "How does Visiopack handle multi-location or multi-branch operations?",
              answer: "Visiopack supports multi-company and multi-warehouse configurations, allowing you to manage inventory, sales, and reporting across all your branches from a single dashboard with consolidated visibility.",
            },
          ]}
          title="We thought you might have questions"
        />
        <News isAbout={true} career={true} />
      </Layout>
    </div >
  )
}

export default MicD365XstakIntegration
export const query = graphql`
  query MicD365XstakIntegrationImages {
    VMLogoBlack: file(relativePath: { eq: "logo_black_LST.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    VMLogoWhite: file(relativePath: { eq: "logo_white_LST.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    HeaderImg: file(
      relativePath: { eq: "caseStudies/visioedgeheader.png" }
    ) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    markFlag: file(relativePath: { eq: "4879902_check_flag_mark_ok_icon_1_copy.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    bgImages: file(relativePath: { eq: "prodbg-01.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img1: file(relativePath: { eq: "caseStudies/Maskgroup9.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img2: file(relativePath: { eq: "caseStudies/Group329.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img3: file(relativePath: { eq: "caseStudies/Group314.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img4: file(relativePath: { eq: "caseStudies/Screenshot2024-01-232121491.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img5: file(relativePath: { eq: "caseStudies/Screenshot2024-01-222140321.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img6: file(relativePath: { eq: "caseStudies/Screenshot2024-01-232238111.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img7: file(relativePath: { eq: "caseStudies/Screenshot2024-01-231916101.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img8: file(relativePath: { eq: "caseStudies/Maskgroup10.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img9: file(relativePath: { eq: "caseStudies/Group314_1.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img10: file(relativePath: { eq: "caseStudies/Maskgroup10.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img11: file(relativePath: { eq: "caseStudies/Maskgroup11.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img12: file(relativePath: { eq: "caseStudies/Maskgroup12.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img13: file(relativePath: { eq: "caseStudies/Maskgroup13.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

